<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="ui-module-card ui-module-fade-in-up" color="primary">
          <div v-if="loading" style="padding: 60px 20px; text-align: center">
            <v-progress-circular indeterminate color="secondary" size="64"></v-progress-circular>
            <div class="text-h6 mt-4">Cargando inventario de equipos...</div>
          </div>

          <div v-else>
          <v-card-title class="ui-module-titlebar font-weight-bold justify-center">Inventario de equipos</v-card-title>
          <v-card-text>
            <v-container fluid>
              <v-row align="center" no-gutters class="mb-4">
                <v-col class="mr-4">
                  <v-select
                    v-model="estatusSeleccionados"
                    :items="estatusDisponibles"
                    multiple
                    clearable
                    chips
                    small-chips
                    rounded
                    filled
                    dense
                    hide-details
                    background-color="transparent"
                    color="secondary"
                    item-color="secondary"
                    class="filter-input"
                    label="Estatus"
                  ></v-select>
                </v-col>
                <v-col class="d-flex align-center">
                  <v-text-field
                    v-model="searchEquipo"
                    rounded
                    filled
                    dense
                    hide-details
                    background-color="transparent"
                    color="secondary"
                    label="Buscar"
                    append-icon="mdi-magnify"
                    class="search-input flex-grow-1"
                  ></v-text-field>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on" class="ml-2">
                        <IconButton variant="secondary" icon="mdi-download" @click="descargarCsv" />
                      </span>
                    </template>
                    <span>Descargar CSV</span>
                  </v-tooltip>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12">
                  <estadisticas-equipo-component :equipos="equiposFiltrados" />
                </v-col>

                <v-col cols="12">
                  <v-data-table
                    :headers="headers"
                    :items="equiposFiltrados"
                    class="primary ui-module-table"
                    :loading="loading"
                  >
                    <template v-slot:[`item.fechaFabricacion`]="{ item }">
                      <span>{{ formatearFecha(item.fechaFabricacion) }}</span>
                    </template>
                    <template v-slot:[`item.aniosVigencia`]="{ item }">
                      <span>{{ formatearFecha(item.aniosVigencia) }}</span>
                    </template>
                    <template v-slot:[`item.opciones`]="{ item }">
                      <v-btn
                        icon
                        class="mr-1 ui-module-icon-action"
                        color="secondary"
                        :loading="loadingEditarEquipo === item.idEquipamiento"
                        @click="openUpdateEquipoDialog(item)"
                        ><v-icon>mdi-pencil</v-icon></v-btn
                      >
                      <v-btn icon class="ui-module-icon-action" color="secondary" @click="openUpdateEstatusEquipoDialog(item)"
                        ><v-icon>mdi-update</v-icon></v-btn
                      >
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <update-equipo-dialog-component
      :active="updateEquipoDialog"
      @close="updateEquipoDialog = false"
      :equipo="selectedEquipo"
    ></update-equipo-dialog-component>
    <estatus-equipo-dialog-component
      :active="updateEstatusEquipoDialog"
      @close="updateEstatusEquipoDialog = false"
      :equipo="selectedEquipo"
    ></estatus-equipo-dialog-component>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import EstatusEquipoDialogComponent from '../../components/equipamiento/EstatusEquipoDialogComponent.vue'
import UpdateEquipoDialogComponent from '../../components/equipamiento/UpdateEquipoDialogComponent.vue'
import EstadisticasEquipoComponent from '../../components/equipamiento/EstadisticasEquipoComponent.vue'
import IconButton from '../../components/base/IconButton.vue'
import downloadCsv from '@/utils/downloadCsv'

export default {
  components: {
    UpdateEquipoDialogComponent,
    EstatusEquipoDialogComponent,
    EstadisticasEquipoComponent,
    IconButton,
  },

  async created() {
    this.$store.commit('equipo/CLEAR_EQUIPO')
    this.loading = true
    await this.fetchEquipo()
    this.loading = false
  },

  data() {
    return {
      loading: false,

      headers: [
        { text: 'Categoría', value: 'CatItem.CatTipoItem.title' },
        { text: 'Item', value: 'CatItem.item' },
        { text: 'Número', value: 'numero' },
        { text: 'Fecha de fabricación', value: 'fechaFabricacion' },
        { text: 'Fecha de vigencia', value: 'aniosVigencia' },
        { text: 'Estatus', value: 'CatEstatus.title' },
        { text: 'Opciones', value: 'opciones' },
      ],

      updateEquipoDialog: false,
      updateEstatusEquipoDialog: false,

      selectedEquipo: null,
      loadingEditarEquipo: false,

      estatusSeleccionados: [],
      searchEquipo: '',
    }
  },

  computed: {
    ...mapGetters('equipo', {
      equipos: 'getEquipos',
    }),

    estatusDisponibles() {
      return [...new Set((this.equipos || []).map((e) => e?.CatEstatus?.title).filter(Boolean))].sort()
    },

    equiposFiltrados() {
      const termino = this.normalizarTexto(this.searchEquipo)
      return (this.equipos || []).filter((equipo) => {
        const estatus = equipo?.CatEstatus?.title || ''

        const coincideEstatus = !this.estatusSeleccionados.length || this.estatusSeleccionados.includes(estatus)
        const coincideBusqueda =
          !termino ||
          [equipo?.CatItem?.item, equipo?.numero, equipo?.fechaFabricacion, estatus].some((campo) =>
            this.normalizarTexto(campo).includes(termino)
          )

        return coincideEstatus && coincideBusqueda
      })
    },
  },

  methods: {
    ...mapActions('equipo', ['fetchEquipo']),

    formatearFecha(valor) {
      if (!valor) return '—'
      const d = new Date(valor + 'T00:00:00')
      return d.toLocaleDateString('es-MX', { day: '2-digit', month: '2-digit', year: 'numeric' })
    },

    normalizarTexto(valor) {
      return (valor || '')
        .toString()
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .toLowerCase()
        .trim()
    },

    descargarCsv() {
      const data = this.equiposFiltrados.map((e) => ({
        Categoría: e?.CatItem?.CatTipoItem?.title || '',
        Item: e?.CatItem?.item || '',
        Número: e?.numero || '',
        'Fecha de fabricación': this.formatearFecha(e?.fechaFabricacion),
        'Fecha de vigencia': this.formatearFecha(e?.aniosVigencia),
        Estatus: e?.CatEstatus?.title || '',
      }))
      downloadCsv(data, { filename: 'inventario-equipos' })
    },

    async openUpdateEquipoDialog(equipo) {
      this.loadingEditarEquipo = equipo.idEquipamiento
      await this.$nextTick()
      this.loadingEditarEquipo = false
      this.selectedEquipo = equipo
      this.updateEquipoDialog = true
    },

    openUpdateEstatusEquipoDialog(equipo) {
      this.selectedEquipo = equipo
      this.updateEstatusEquipoDialog = true
    },
  },
}
</script>

<style scoped>
.ui-module-card {
  background: rgba(30, 30, 46, 0.6) !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 159, 67, 0.2);
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
}

/* Tabla de datos */
::v-deep .v-data-table {
  background: transparent !important;
  color: #e0e0e0 !important;
}

::v-deep .v-data-table-header {
  background: rgba(255, 159, 67, 0.15) !important;
}

::v-deep .v-data-table-header th {
  color: #e0e0e0 !important;
  font-weight: 600 !important;
  border-bottom: 2px solid rgba(255, 159, 67, 0.3) !important;
}

::v-deep .v-data-table tbody tr {
  transition: all 0.3s ease;
}

::v-deep .v-data-table tbody tr:hover {
  background: rgba(255, 159, 67, 0.1) !important;
}

::v-deep .v-data-table tbody td {
  color: #e0e0e0 !important;
  border-bottom: 1px solid rgba(255, 159, 67, 0.1) !important;
}

::v-deep .v-data-footer {
  background: rgba(46, 36, 22, 0.4) !important;
  border-top: 1px solid rgba(255, 159, 67, 0.2) !important;
  color: #e0e0e0 !important;
}

/* Inputs de filtros y búsqueda */
::v-deep .search-input .v-input__slot,
::v-deep .filter-input .v-input__slot {
  border-radius: 12px !important;
  border: 1px solid rgba(255, 159, 67, 0.25) !important;
  background: rgba(16, 16, 30, 0.35) !important;
}

::v-deep .search-input .v-input__slot:hover,
::v-deep .filter-input .v-input__slot:hover {
  border-color: rgba(255, 159, 67, 0.45) !important;
}

::v-deep .search-input .v-input__control,
::v-deep .filter-input .v-input__control {
  background: transparent !important;
  border-radius: 12px;
  border: none !important;
  box-shadow: none !important;
}

::v-deep .search-input .v-input__slot input,
::v-deep .filter-input .v-input__slot input,
::v-deep .filter-input .v-select__selection,
::v-deep .filter-input .mdi-menu-down,
::v-deep .search-input .mdi-magnify {
  color: #e0e0e0 !important;
}

::v-deep .search-input .v-label,
::v-deep .filter-input .v-label {
  color: rgba(224, 224, 224, 0.7) !important;
}

::v-deep .search-input.v-input--is-focused .v-label,
::v-deep .filter-input.v-input--is-focused .v-label {
  color: #ffbe76 !important;
}

/* Botones */
::v-deep .v-btn {
  border-radius: 12px;
  text-transform: none;
  font-weight: 600;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

::v-deep .v-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(255, 159, 67, 0.3);
}

::v-deep .v-btn.v-btn--icon {
  background: rgba(255, 159, 67, 0.1);
  border: 1px solid rgba(255, 159, 67, 0.2);
}

::v-deep .v-btn.v-btn--icon:hover {
  background: rgba(255, 159, 67, 0.2);
  border-color: #ff9f43;
}

::v-deep .v-icon {
  color: #ffbe76 !important;
  transition: all 0.3s ease;
}

::v-deep .v-btn:hover .v-icon {
  color: #ff9f43 !important;
  transform: scale(1.2);
}

/* Scrollbar */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(10, 10, 10, 0.5);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: rgba(255, 159, 67, 0.4);
  border-radius: 4px;
  transition: background 0.3s;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 159, 67, 0.6);
}
</style>
